/**
 * TutorialCompleteModal — the congratulations at the end.
 *
 * Shown on whatever page the last step landed on, which is the home page,
 * because publishing navigates there.
 */

import React from 'react';
import styles from './TutorialModal.module.css';

const TutorialCompleteModal = ({ content, onClose, onViewScenarios }) => (
    <div className={styles.modalOverlay} data-tutorial-ui="complete">
        <div className={styles.modalContent} role="dialog" aria-modal="true" aria-label={content.title}>
            <h2 className={styles.modalTitle}>{content.title}</h2>
            <p className={styles.modalDescription}>{content.body}</p>
            <p className={styles.modalNote}>{content.note}</p>

            <div className={styles.buttonGroup}>
                {onViewScenarios && (
                    <button
                        type="button"
                        className={`${styles.buttonBase} ${styles.primaryButton}`}
                        onClick={onViewScenarios}
                    >
                        {content.view}
                    </button>
                )}
                <button
                    type="button"
                    className={`${styles.buttonBase} ${
                        onViewScenarios ? styles.secondaryButton : styles.primaryButton
                    }`}
                    onClick={onClose}
                >
                    {content.close}
                </button>
            </div>
        </div>
    </div>
);

export default TutorialCompleteModal;
